<template>
  <div class="slds-grid slds-grid_frame slds-wrap slds-grid_vertical slds-grid_vertical-stretch slds-p-around_medium" style="padding:0.4rem;">
    <app-page-header/> 
    <div class="slds-col slds-grid slds-grid_vertical slds-p-top_none">
      <div class="slds-box page-header slds-text-align_center slds-p-top_small slds-p-left_small slds-p-bottom_small slds-p-right_small slds-m-top_small">
        <div class="slds-text-heading_large" style="font-size:30px;line-height:64px;color:#014486;font-weight:bold; ">SDO/IDO Demo Tools No Longer Available</div>
        <div class="slds-align_absolute-center">
          <p class="slds-text-heading_small" style="width:50%;line-height:21px;font-size:15px;font-weight:500">Trust is the bedrock of our company. It is written in the DNA of our culture, technology, and focus on customer success. Security is a big part of trust, and to ensure that Salesforce information continues to remain secure, we are reviewing all externally-facing applications for vulnerabilities.</p>
        </div>
        <div class="slds-align_absolute-center">
          <p class="slds-text-heading_small" style="margin-top:20px;width:50%;line-height:21px;font-size:15px;font-weight:500">Perfect Date Wizard, Task and Event Generator, CPQ Console, Data Generator, Org Customiser & Demo Wizard are no longer available in SDO or the IDOs</p>
       </div>
      </div>
      <div class="slds-grid slds-grid--vertical-stretch slds-gutters slds-wrap slds-p-left_xx-large slds-p-right_xx-large">
        <div class="slds-col slds-size_1-of-3 slds-p-top_small" >
          <card-view/>
        </div>
      </div>
    </div>
    <page-footer/>
  </div>
</template>

<script>
import PageHeader from './components/PageHeader.vue'
import CardView from './components/CardView.vue'
import PageFooter from './components/PageFooter.vue'
import { mixpanelMixin } from './mixpanelMixin'

export default {
  name: 'app',
  mixins: [mixpanelMixin],
  data() {
    return{
      mixpaneltoken: String,
    }
  },
  components: {
    appPageHeader: PageHeader,
    CardView,
    PageFooter,
  },
 computed:{
  },
}
</script>

<style scoped>
  .page-header{
      background: url("/demo-wizard-banner-img.jpg");
      width: 100%;
      background-repeat: round !important;
      background-size: cover !important;
  }
  .custom-button{
    border-radius: 20px;
    width: unset;
    background: #2D9CED;
    font-size: 15px;
    border-color: transparent;
    padding-top: 7px;
    padding-bottom: 7px;
    padding-right: 20px;
    padding-left: 20px;
  }
</style>